<template>
    <div id="credibility-section" class="row d-flex align-items-center fluid">
        <div v-for="(badge,index) in badges" :key="badge.key" class="credibility-badge col-4 col-sm-2 col-md-2 col-lg-2 align-middle pe-3 ps-3">
            <img :src="badge.img" :alt="badge.alt" :title="badge.alt" class="img-fluid" />
        </div>
    </div>
</template>

<script>
import loanOptionsImg from '../../../assets/PFS-credibility-200loanoptions.png';
import coastToCoastImg from '../../../assets/PFS-credibility-coasttocoast.png';
import loansImg from '../../../assets/PFS-credibility-700kloans.png';
import digitalProcessImg from '../../../assets/PFS-credibility-digital-process.png';
import fortuneImg from '../../../assets/PFS-credibility-16yrsfortune.png';
import zillowImg from '../../../assets/PFS-credibility-5starzillow.png';
    export default {
        name: 'credibility',
        data() {
            return {
                badges: [
                { img: loanOptionsImg, alt: 'We offer more than 200 different loan options', key: '200loanoptions' },
                { img: coastToCoastImg, alt: 'Pulte Mortgage services states from coast to coast', key: 'costtocoast' },
                { img: loansImg, alt: 'More than 700,000 homes financed since 1972', key: '700kloans' },
                { img: digitalProcessImg, alt: 'High touch digital mortgage experience', key: 'digitalprocess' },
                { img: fortuneImg, alt: '16 consecutive years Fortune 500 Corporation', key: '16yrsfortune' },
                { img: zillowImg, alt: 'We have a 5 Star Zillow Rating', key: '5starzillow' }
                ]
            };
        }
    };
</script>

<style lang="scss">
    .home {
        #credibility-section
        {
        margin: auto !important;
        background-color: #53798d;
        text-align: center;
        padding: 10px 0 10px 0;


        @media (max-width: 991px) {
            .credibility-badge {
                padding: 10px 0 10px 0;
                img
                    {
                    height: auto;
                    padding: inherit 5em inherit 5em;
                    vertical-align: middle;
                    max-width: 70%;
                    }
                }
        }


    @media (max-width: 767px) {
        .credibility-badge {
            padding: 5px 0 5px 0;
            img

            {
                height: auto;
                vertical-align: middle;
                max-width: 90%;
            }

        }
    }

    @media (min-width: 992px) {
        .credibility-badge {
            padding: 20px 0 20px 0;
            img

            {
                height: auto;
                padding: inherit 5em inherit 5em;
                vertical-align: middle;
                max-width: 50%;
            }

        }
    }

    @media (min-width: 1200px) {
        .credibility-badge {
            padding: 5px 0 5px 0;
            img

            {
                height: auto;
                vertical-align: middle;
                max-width: 50%;
            }

        }
    }
    }
    }
</style>